<template>
  <div v-if="!item.hidden" class="menu-wrapper">
    <template v-if="hasOneShowingChild(item.children,item) && (!onlyOneChild.children||onlyOneChild.noShowingChildren)&&!item.alwaysShow">
      <menuLink v-if="onlyOneChild.meta" :to="Routelink(onlyOneChild)">
        <el-menu-item :index="onlyOneChild.path" :class="{'submenu-title-noDropdown':!isNest}">
          <i :class="onlyOneChild.meta.icon" v-if="onlyOneChild.meta.icon" />
          <span slot="title">
            {{ onlyOneChild.meta.title }}
            <i
              v-if="onlyOneChild.path === '/pendingApproval' && pendingApprovalNum && pendingApprovalNum.activityCount > 0"
              class="tipsNum"
              :class="pendingApprovalNum.activityCount > 9 ? 'widening' : ''"
            >
              <span>{{ pendingApprovalNum.activityCount > 99 ? '99+' : pendingApprovalNum.activityCount }}</span>
            </i>
          </span>
        </el-menu-item>
      </menuLink>
    </template>
    <el-submenu v-else ref="subMenu" :index="item.name" popper-append-to-body>
      <template slot="title">
        <i :class="item.meta.icon" v-if="item.meta.icon" />
        <span slot="title">{{ item.meta.title }}</span>
      </template>
      <menuItem
        v-for="child in item.children"
        :key="child.name"
        :is-nest="true"
        :item="child"
        class="nest-menu"
      />
    </el-submenu>
  </div>
</template>
<script type="es6">
import { isExternal } from '@/utils/utils';
import menuLink from './menuLink';
import { mapState } from 'vuex';
export default {
  name: 'MenuItem',
  data () {
    this.onlyOneChild = null;
    return {
    };
  },
  props: {
    // route object
    item: {
      type: Object,
      required: true
    },
    isNest: {
      type: Boolean,
      default: false
    }
  },
  components: {
    menuLink
  },
  computed: {
    ...mapState({
      pendingApprovalNum: state => state.pendingApprovalNum
    })
  },
  methods: {
    hasOneShowingChild (children = [], parent) {
      const showingChildren = children.filter(item => {
        if (item.hidden) {
          return false;
        } else {
          // Temp set(will be used if only has one showing child)
          this.onlyOneChild = item;
          return true;
        }
      });
      // When there is only one child router, the child router is displayed by default
      if (showingChildren.length === 1) {
        return true;
      }
      // Show parent if there are no child router to display
      if (showingChildren.length === 0) {
        this.onlyOneChild = { ...parent, noShowingChildren: true };
        return true;
      }
      return false;
    },
    Routelink (route) {
      if (isExternal(route.path)) {
        return { fullPath: route.path, target: route.target || '_blank' };
      } else {
        return route;
      }
    }
  },
  mounted () {

  }
};
</script>
<style lang="scss">
.el-menu--collapse .el-submenu>.el-submenu__title{
  span {
    height: 0;
    width: 0;
    overflow: hidden;
    visibility: visible;
    display: inline-block;
  }
  .el-submenu__icon-arrow {
    display: none;
  }
}
</style>
